// extracted by mini-css-extract-plugin
module.exports = {"combined-price-control":"CombinedPriceControl_combined-price-control__1TRbG","label":"CombinedPriceControl_label__B2il3","button":"CombinedPriceControl_button__1Wi-V"};